import React from 'react';
import classnames from 'classnames';
import { FadeEffectProps } from './types';
import './styles.scss';

const FadeEffect: React.FC<FadeEffectProps> = ({ reverse }) => {
    return (
        <div className={classnames("fade-effect", {
            'fade-effect--reverse': reverse
        })} />
    )
}

export default FadeEffect;
